import axios from 'axios'

export default {
    get: () => axios.get('challenges'),
    getFiltered: (data) => axios.post('challenges', data),
    getActives: () => axios.get('active-challenges'),
    show: (id) => axios.get('challenges/'+id+'/show'),
    store: (data) => axios.post('challenges/store', data),
    update: (data) => axios.post('challenges/update', data),
    delete: (id) => axios.post('challenges/delete', id),
    resetChallenge: (data) => axios.post('challenges/reset', data),
    winnersChallenge: (data) => axios.post('challenges/winners', data),
    validationPointsChallenge: (data) => axios.post('challenges/validation-points', data),
    reactive: (data) => axios.post('challenges/reactive', data),
    deactive: (data) => axios.post('challenges/deactive', data),
    completeChallenge: (challenge_id) => axios.post('challenges/complete', {challenge_id: challenge_id}),
    addVideo: (data) => axios.post('challenges/add-video', data),
    deleteVideo: (data) => axios.post('challenges/remove-video', data),
    changeRate: (data) => axios.post('challenges/change-video-rate', data),
    updateAwards: (data) => axios.post('challenges/update-awards', data),
    updateManagerAwards: (data) => axios.post('challenges/update-manager-awards', data),
    updateRules: (data) => axios.post('challenges/update-rules', data),
    updateManagerRules: (data) => axios.post('challenges/update-manager-rules', data),
    getQuestions: (challenge_id) => axios.get('challenges/'+challenge_id+'/simple-questions'),
    storeQuestion: (data) => axios.post('challenges/questions/store', data),
    updateQuestion: (data) => axios.post('challenges/questions/update', data),
    deleteQuestion: (id) => axios.post('challenges/questions/delete', id),

    //Obtiene el folio del concurso
    nextCodeChallenge: () => axios.get('challenges/next-code'),
    
    //Elimina un archivo de una pregunta
    deleteFileQuestion: (data) => axios.post('challenges/questions/delete-file', data),

    //Dinamicas de Objetivos
    getObjectives: (challenge_id) => axios.get('challenges/'+challenge_id+'/objectives'),
    updateObjectives: (data) => axios.post('challenges/update-objectives', data),
    storeObjectives: (data) => axios.post('challenges/store-objectives', data),
    deleteObjectives: (id) => axios.delete('challenges/delete-objectives/'+id),
    deleteAllObjectives: (challenge_id) => axios.post('challenges/delete-all-objectives', {challenge_id: challenge_id}),
    //Obtiene los participantes de una dinamica de objetivos
    getSuppliersObjectives: (objective_id) => axios.get('challenges/objectives/'+objective_id+'/suppliers'),
    updateSuppliersObjectives: (challenge_id, objective_id,data) => axios.post('challenges/'+challenge_id+'/objectives/'+objective_id+'/suppliers/update', data),

    //Dinamicas de Reglas de los objetivos
    storeRules: (data) => axios.post('challenges/store-objective-rules', data),
    deleteRules: (id) => axios.delete('challenges/delete-objective-rules/'+id),

    //Dinamicas de Grupos de Reglas de los objetivos
    storeRuleGroup: (data) => axios.post('challenges/store-objective-rule-group', data),
    deleteRuleGroup: (id) => axios.delete('challenges/delete-objective-rule-group/'+id),

    //Obtenemos las plantillas de reglas para asignar a los objetivos
    getObjectivesRulesTemplate: (challenge_id) => axios.get('challenges/objectives-rules-template/'+challenge_id),
    //Importamamos objetivos
    importObjectives: (data) => axios.post('challenges/import-objectives', data),

    downloadAnswers: (challenge_id) => axios.post('challenges/questions/'+challenge_id+'/download-answers').then(function(response){
        if(response.type == "success"){
            window.open(response.data, '_blank');
        }
    }),

    downloadParticipants: (challenge_id) => axios.post('challenges/'+challenge_id+'/download-participants').then(function(response){
        if(response.type == "success"){
            window.open(response.data, '_blank');
        }
    }),
    
    getEntries: (challenge_id) => axios.get('challenges/'+challenge_id+'/entries'),
    getTopEntries: (challenge_id) => axios.get('challenges/'+challenge_id+'/entries/top-30'),
    
    getCedis: (challenge_id) => axios.get('challenges/'+challenge_id+'/cedis'),
    getEntriesByCedis: (challenge_id, cedis_id) => axios.get('challenges/'+challenge_id+'/entries-by-cedis/'+cedis_id),

    deleteEntry: (id) => axios.post('challenges/entries/delete', id),
    paidEntry: (id) => axios.post('challenges/entries/paid', id),
    unpaidEntry: (id) => axios.post('challenges/entries/unpaid', id),
    getAvailables: (challenge_id) => axios.get('challenges/'+challenge_id+'/availables'),
    getAvailablesByManager: (challenge_id, manager_id) => axios.get('challenges/'+challenge_id+'/availables-by-manager/'+manager_id),
    deleteAvailable : (id) => axios.post('challenges/availables/delete', id),
    importAvailables: (data) => axios.post('challenges/availables/import', data),
    addSupplier: (data) => axios.post('challenges/availables/add-supplier', data),

    getCustomers: (challenge_id) => axios.get('challenges/'+challenge_id+'/customers'),
    addCustomer: (data) => axios.post('challenges/customers/add-customer', data),
    deleteCustomer : (id) => axios.post('challenges/customers/delete-customer', id),
    importCustomers: (data) => axios.post('challenges/customers/import', data),

    saveAnswers: (data) => axios.post('challenges/questions/answers', data),
    uploadQuestion: (data) => axios.post('challenges/questions/upload', data),

    getProducts: (challenge_id) => axios.get('challenges/'+challenge_id+'/products'),
    deleteProduct: (id) => axios.post('challenges/products/delete', id),
    importProducts: (data) => axios.post('challenges/products/import', data),
    storeProduct: (data) => axios.post('challenges/products/store', data),
    updateProduct: (data) => axios.post('challenges/products/update', data),

    getSales: (challenge_id) => axios.get('challenges/'+challenge_id+'/sales'),
    getSalesFiltered : (challenge_id, filters) => axios.post('challenges/'+challenge_id+'/sales', filters),
    deleteSale: (id) => axios.post('challenges/sales/delete', id),

    getProgress: (challenge_id) => axios.post('challenges/get-progress', {challenge_id: challenge_id}),
}